import React from 'react';
import { Alert, Typography, Box, Chip } from '@mui/material';

const SelectedContextsAlert = ({ chatContexts = [], chatContext = null, onClearAll, onRemoveContext, showClearHint = false }) => {
  const hasAny = (Array.isArray(chatContexts) && chatContexts.length > 0) || !!chatContext;
  if (!hasAny) return null;

  return (
    <Alert severity="info" onClose={onClearAll} sx={{ m: 2, mt: 0 }}>
      <Typography variant="caption" display="block" gutterBottom>
        <b>{chatContexts.length > 0 ? `${chatContexts.length} Contexts Selected` : 'Context Selected'}:</b>
      </Typography>
      {showClearHint && <Typography variant="caption">Click X to clear all contexts</Typography>}
      <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {chatContexts
          .filter((ctx) => ctx.selectionType === 'report' && (ctx.label || ctx.href))
          .map((ctx) => (
            <Chip
              key={ctx.id}
              size="small"
              variant="outlined"
              color="info"
              label={`${ctx.reportType || 'Report'}: ${ctx.label || 'link'}`}
              {...(ctx.href ? { component: 'a', href: ctx.href, target: '_blank', clickable: true } : {})}
              onDelete={() => onRemoveContext && onRemoveContext(ctx.id)}
            />
          ))}
      </Box>
    </Alert>
  );
};

export default SelectedContextsAlert;
